// src/components/ServersParser/ServersParserHero.jsx
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ServersParserHero = () => {
  const { t } = useLanguage();

  return (
    <section className="sp-hero-wrap">
      <h1 className="sp-hero-title">
        MONITORING <span className="sp-hero-title-accent">PARSER</span>
      </h1>
      <p className="sp-hero-subtitle">
        {t('parserDescription') || 'Анализируйте популярные сайты мониторинга серверов для поиска уязвимых серверов или серверов с определенными параметрами.'}
      </p>
    </section>
  );
};

export default ServersParserHero;
